const ForsiaEmailIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.77966 7.7805C3.77965 7.78048 3.77966 7.78052 3.77966 7.7805Z"
        fill="#C5E86C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.2693 7.38122C2.25668 7.43578 2.25 7.49262 2.25 7.55103V17C2.25 19.0712 3.92879 20.75 6 20.75H18C20.0712 20.75 21.75 19.0712 21.75 17V7.56206C21.75 7.55871 21.75 7.55535 21.75 7.552C21.75 5.72798 20.2724 4.25 18.449 4.25H5.56601C3.79974 4.25 2.35766 5.63692 2.2693 7.38122ZM3.75 10.3081V17C3.75 18.2428 4.75721 19.25 6 19.25H18C19.2428 19.25 20.25 18.2428 20.25 17V10.3183L15.7949 13.3388C13.5078 14.889 10.5073 14.8891 8.22021 13.3388L3.75 10.3081ZM18.1162 9.95275L19.4591 9.04222C19.9513 8.70942 20.2476 8.15418 20.25 7.55943V7.55203C20.25 7.55067 20.25 7.5493 20.25 7.54795C20.2478 6.55384 19.4423 5.75 18.449 5.75H5.56601C4.57123 5.75 3.76501 6.55621 3.76501 7.551C3.76501 7.62829 3.76997 7.70492 3.77966 7.7805C3.84489 8.28913 4.12486 8.75015 4.55573 9.04211L9.06182 12.0972C10.8407 13.3029 13.1743 13.3029 14.9531 12.0972L18.1162 9.95275Z"
        fill="#C5E86C"
      />
    </svg>
  );
};

export default ForsiaEmailIcon;
